import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
export class ResendOTPButton extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isButtonDisabled: true,
      clickCount: 0,
    }
  }
  componentDidMount() {
    setTimeout(() => {
      this.setState({ isButtonDisabled: false }, () => {
        this.props.onButtonStateChanged(!this.setState.isButtonDisabled)
      })
    }, 30000)
  }
  componentDidUpdate() {
    if (this.state.timer === 1) {
      clearInterval(this.interval)
    }
  }
  componentWillUnmount() {
    clearInterval(this.interval)
  }
  resendOtp = () => {
    this.setState({
      isButtonDisabled: true,
      clickCount: this.state.clickCount + 1,
    })

    setTimeout(() => {
      if (this.state.clickCount < 2) {
        this.setState({ isButtonDisabled: false }, () => {
          this.props.onButtonStateChanged(!this.setState.isButtonDisabled)
        })
      }
    }, 30000)

    this.interval = setInterval(() => {
      return this.setState((prevState) => {
        return { timer: prevState.timer - 1 }
      })
    }, 1000)

    this.props.onRequestOTP()
  }

  render() {
    return (
      <ReactBootstrap.Button
        variant="link"
        className="p-0 float-left btn text-dark btn-sm"
        type="button"
        disabled={this.state.isButtonDisabled}
        onClick={this.resendOtp}
      >
        Resend OTP
      </ReactBootstrap.Button>
    )
  }
}
